var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReemEight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 52,
    viewBox: "0 0 102 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.412 23L49.102 19.598H48.36V23H45.98V13.2H50.348C52.42 13.2 53.708 14.432 53.708 16.476C53.708 18.044 52.952 18.982 51.748 19.374L54.324 23H51.412ZM51.3 16.504C51.3 15.818 50.88 15.468 50.082 15.468H48.36V17.512H50.082C50.908 17.512 51.3 17.176 51.3 16.504ZM62.4077 15.468H58.0397V16.924H62.0157V19.192H58.0397V20.732H62.4077V23H55.6597V13.2H62.4077V15.468ZM70.6245 15.468H66.2565V16.924H70.2325V19.192H66.2565V20.732H70.6245V23H63.8765V13.2H70.6245V15.468ZM79.2053 13.2H81.9073V23H79.5273V16.532L77.0773 20.27H76.8533L74.4033 16.532V23H72.0233V13.2H74.7253L76.9653 16.56L79.2053 13.2ZM52.728 30.468H48.36V31.924H52.336V34.192H48.36V35.732H52.728V38H45.98V28.2H52.728V30.468ZM54.1968 38V28.2H56.5768V38H54.1968ZM62.6188 32.582H68.0648V38H66.0348V36.628C65.6008 37.496 64.4948 38.182 62.9548 38.182C60.2528 38.182 58.1108 36.068 58.1108 33.128C58.1108 30.188 60.2528 28.018 63.1928 28.018C65.6008 28.018 67.4348 29.474 67.9668 31.532H65.4188C65.0268 30.748 64.2288 30.286 63.1928 30.286C61.5688 30.286 60.5188 31.434 60.5188 33.156C60.5188 34.724 61.3868 35.984 63.1368 35.984C64.2148 35.984 65.1388 35.508 65.5308 34.57H62.6188V32.582ZM76.1065 28.2H78.4865V38H76.1065V34.136H72.3405V38H69.9605V28.2H72.3405V31.868H76.1065V28.2ZM87.5308 28.2V30.468H84.8568V38H82.4768V30.468H79.8168V28.2H87.5308Z",
    fill: "#3C373A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_539_1901)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6072 24.1883C35.5028 22.1515 36 19.8992 36 17.5306C36 8.40101 28.6127 1 19.5 1C10.3873 1 3 8.40101 3 17.5306C3 19.4631 3.33098 21.3181 3.93925 23.0418L3.91699 23.041C3.98013 23.1946 4.04442 23.3487 4.10984 23.5032C4.29607 23.9845 4.50414 24.4549 4.73284 24.9132C8.10427 32.2465 13.8023 40.2916 19.5003 46.0002C25.6878 39.8012 32.242 29.8829 34.6253 24.189L34.6072 24.1883Z",
    fill: "#3C373A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.5,
    cy: 16.3216,
    rx: 9.42857,
    ry: 9.42857,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_539_1901",
    x: 0,
    y: 1,
    width: 39,
    height: 51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_539_1901"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_539_1901",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReemEight);
export default __webpack_public_path__ + "static/media/Reem Eight.4f6bf3468bf523d6740c8d76c43b2280.svg";
export { ForwardRef as ReactComponent };